var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#01A601;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,0c1.6,0,3,0.4,4.3,1c-0.5,0.4-1,0.8-1.5,1.2C11.9,1.9,11,1.7,10,1.7c-2.3,0-4.4,0.9-5.9,2.4 C2.6,5.6,1.7,7.7,1.7,10s0.9,4.4,2.4,5.9s3.6,2.4,5.9,2.4s4.4-0.9,5.9-2.4c1.5-1.5,2.4-3.6,2.4-5.9c0-0.5-0.1-1.1-0.2-1.6 c0.4-0.6,0.9-1.1,1.3-1.7c0.4,1,0.5,2.1,0.5,3.3c0,2.8-1.1,5.3-2.9,7.1S12.8,20,10,20s-5.3-1.1-7.1-2.9C1.1,15.3,0,12.8,0,10 s1.1-5.3,2.9-7.1S7.2,0,10,0L10,0z M5.3,8.4l2.4,0l0.2,0c0.5,0.3,1,0.6,1.4,1c0.3,0.3,0.6,0.6,0.9,0.9c0.9-1.4,1.8-2.7,2.8-3.9 c1.1-1.3,2.2-2.5,3.4-3.6l0.2-0.1h2.7l-0.5,0.6c-1.6,1.8-3.1,3.7-4.5,5.7c-1.4,2-2.6,4-3.6,6.1l-0.3,0.6L10.1,15 c-0.6-1.2-1.2-2.3-2.1-3.3S6.2,9.8,5.1,9L5.3,8.4L5.3,8.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.04d829712754f5d00837bb09f0ccb4a8.svg";
export { ForwardRef as ReactComponent };